module.exports = __webpack_public_path__ + "static/img/8.66c87e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/eng/8.png
// module id = 3V9K
// module chunks = 0